import React from 'react'
import { Button, Dialog, IconButton, TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'
import { MdClose } from 'react-icons/md'
import { rootUrl } from '../../../config/App'

const Fluxsis = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    const [isModal, setModal] = React.useState(false)

    return (
        <>
            <Dialog
                open={isModal}
                maxWidth="sm"
                style={{width: '100%'}}
                onClose={() => setModal(false)}
                className="center"
            >       
                <div className="d-flex justify-content-end">
                    <IconButton
                        onClick={() => setModal(false) }
                    >
                        <MdClose />
                    </IconButton>
                </div>
                <video className="help-video" controls>
                    <source src={rootUrl+'/fluxsis.mov'} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </Dialog>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Nome do Titular da Conta Fluxsis</label>
                <TextField
                    error={(error.fluxsis_name_holder) && true}
                    value={account.fluxsis_name_holder || ''}
                    placeholder="Nome Completo do Titular da conta Fluxsis"
                    onChange={e => {
                        dispatch(change({fluxsis_name_holder: e.target.value}))
                        if (error.fluxsis_name_holder && delete error.fluxsis_name_holder);
                    }}
                />

                {(error.fluxsis_name_holder) &&
                    <strong className="text-danger">{error.fluxsis_name_holder[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.fluxsis_client_id) && true}
                    value={account.fluxsis_client_id || ''}
                    onChange={e => {
                        dispatch(change({fluxsis_client_id: e.target.value}))
                        if (error.fluxsis_client_id && delete error.fluxsis_client_id);
                    }}
                />

                {(error.fluxsis_client_id) &&
                    <strong className="text-danger">{error.fluxsis_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.fluxsis_client_secret) && true}
                    value={account.fluxsis_client_secret || ''}
                    onChange={e => {
                        dispatch(change({fluxsis_client_secret: e.target.value}))
                        if (error.fluxsis_client_secret && delete error.fluxsis_client_secret);
                    }}
                />

                {(error.fluxsis_client_secret) &&
                    <strong className="text-danger">{error.fluxsis_client_secret[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Chave Pix</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.fluxsis_pix_key) && true}
                    value={account.fluxsis_pix_key || ''}
                    onChange={e => {
                        dispatch(change({fluxsis_pix_key: e.target.value}))
                        if (error.fluxsis_pix_key && delete error.fluxsis_pix_key);
                    }}
                />

                {(error.fluxsis_pix_key) &&
                    <strong className="text-danger">{error.fluxsis_pix_key[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <Button 
                    variant="contained"
                    color="default"
                    className="fw-bolder bg-white"
                    size="small"
                    onClick={() => setModal(true)}
                >
                    Ajuda com as Credenciais
                </Button>
            </div>
        </>
    )
}


export default Fluxsis